import { SagaIterator } from 'redux-saga';
import { all, takeLatest, select, call, put } from 'redux-saga/effects';
import {
  SAVE_CARD,
  SaveCardAction,
  GET_CARDS,
  PaymentCard,
  SelectCardActions,
  SET_SELECTED_CARDS,
} from './types';
import { getUserState } from '../user/selector';
import { MCAFirebaseSaga } from '../root-saga';
import { setLoading } from '../app-globals/actions';
import { firestore } from '../../constants/firebase';
import { FirestoreSnapshot } from '../meals/types';
import { setCards, getCards } from './actions';

function* saveCard({ card }: SaveCardAction): SagaIterator<void> {
  console.log(card);
  try {
    yield put(setLoading(true, 'Saving Card'));
    const { user } = yield select(getUserState);
    delete card.cid;
    const body = {
      user: user.userid,
      type: user.accountType,
      ...card,
    };
    const save = yield call(
      MCAFirebaseSaga.firestore.addDocument,
      'cards',
      body
    );
    yield put(setLoading(false, ''));
    console.log('save', save);
  } catch (e) {
    console.log('error', e);
    yield put(setLoading(false, ''));
  }
}

function* fetchCards(): SagaIterator<void> {
  try {
    // yield put(setLoading(true, 'Fetching Cards'));
    const { user } = yield select(getUserState);
    const cardsRef = firestore
      .collection('cards')
      .where('user', '==', user.userid);

    const snapshot = yield call(
      MCAFirebaseSaga.firestore.getCollection,
      cardsRef
    );

    const cards: PaymentCard[] = [];

    snapshot.forEach((item: FirestoreSnapshot) => {
      const body = {
        cid: item.id,
        ...item.data(),
      };
      cards.push(body);
    });

    yield put(setLoading(false, ''));
    yield put(setCards(cards));
    console.log('cards', cards);
  } catch (e) {
    console.log('error', e);
    yield put(setLoading(false, ''));
  }
}

function* selectCard({ cid, selected }: SelectCardActions): SagaIterator<void> {
  try {
    yield put(setLoading(true, 'Selecting card'));
    const body = {
      selected: selected,
    };
    yield call(MCAFirebaseSaga.firestore.updateDocument, `cards/${cid}`, body);
    yield put(setLoading(false, ''));
    // yield put(getCards());
  } catch (error) {
    yield put(setLoading(false, error));
  }
}

export function* PaymentSaga() {
  yield all([
    takeLatest(SAVE_CARD, saveCard),
    takeLatest(GET_CARDS, fetchCards),
    takeLatest(SET_SELECTED_CARDS, selectCard),
  ]);
}
